// extracted by mini-css-extract-plugin
export default {"index":"icp_index__Z3ZhG"};